import React, { useEffect, useState } from "react";
import ProductListingStore from "./Components/ProductListingStore";
import ProductListingProduct from "./Components/ProductListingProduct";
import ProductListingCategory from "./Components/ProductListingCategory";
import ProductListingAttributes from "./Components/ProductListingAttributes";
import ProductListingImages from "./Components/ProductListingImages";
import ProductListingVariations from "./Components/ProductListingVariations";
import ProductListingPricing from "./Components/ProductListingPricing";
import ProductListingInventory from "./Components/ProductListingInventory";
import ProductListingReview from "./Components/ProductListingReview";
import ProductListingPublish from "./Components/ProductListingPublish";
import fetchStoreListForProductListingService from "../../../../Service/OPSServices/AmazonProductListing/fetchStoreListForProductListingService";
import { connect } from 'react-redux';

const stepsConfig = [
  { key: "store", label: "Store" },
  { key: "product", label: "Product" },
  { key: "category", label: "Category" },
  { key: "attributes", label: "Attributes" },
  { key: "images", label: "Images" },
  { key: "variations", label: "Variations" },
  { key: "pricing", label: "Pricing" },
  { key: "inventory", label: "Inventory" },
  { key: "review", label: "Review" },
  { key: "publish", label: "Publish" }
];

function ProductListingHeader(props) {
  const activeIndex = stepsConfig.findIndex((s) => s.key === props.activeTab);
  const [storeList, setStoreList] = useState([])

  useEffect(() => {
    fetchStoreListForProductListingService(props.token).then((res) => {
      if (res) {
        console.log(res);
        setStoreList(res.storeList)
      }
    });
  }, []);
  return (
    <div className="amazon-listing-header-container">
      <h5 className="amazon-listing-sidebar-title ml-4 mt-3">
        Create Amazon Listing
        </h5>
      <div className="amazon-progress-bar ml-4 mt-2">
        {stepsConfig.map((step, index) => {
          let status = index < activeIndex ? "completed" : index === activeIndex ? "active" : "inactive";

          return (
            <div
              key={step.key}
              className={`progress-step ${status}`}
              style={{ zIndex: stepsConfig.length - index, cursor: "pointer" }}
              onClick={() => props.setActiveTab(step.key)} 
            >
             <span className="step-icon">
                {index + 1}
            </span>
              <span className="step-label">{step.label}</span>
            </div>
          );
        })}
      </div>

      <div className="amazon-listing-content mt-4 ml-3 mr-3">
        {props.activeTab === "store" && <ProductListingStore nextStep={props.handleNext} prevStep={props.handleBack} storeList={storeList}/>}
        {props.activeTab === "product" && <ProductListingProduct nextStep={props.handleNext} prevStep={props.handleBack} listingData={props.listingData}/>}
        {props.activeTab === "category" && <ProductListingCategory nextStep={props.handleNext} prevStep={props.handleBack} listingData={props.listingData}/>}
        {props.activeTab === "attributes" && <ProductListingAttributes nextStep={props.handleNext} prevStep={props.handleBack} listingData={props.listingData}/>}
        {props.activeTab === "images" && <ProductListingImages nextStep={props.handleNext} prevStep={props.handleBack} listingData={props.listingData}/>}
        {props.activeTab === "variations" && <ProductListingVariations nextStep={props.handleNext} prevStep={props.handleBack} listingData={props.listingData}/>}
        {props.activeTab === "pricing" && <ProductListingPricing nextStep={props.handleNext} prevStep={props.handleBack} listingData={props.listingData}/>}
        {props.activeTab === "inventory" && <ProductListingInventory nextStep={props.handleNext} prevStep={props.handleBack} listingData={props.listingData}/>}
        {props.activeTab === "review" && <ProductListingReview nextStep={props.handleNext} prevStep={props.handleBack} listingData={props.listingData}/>}
        {props.activeTab === "publish" && <ProductListingPublish nextStep={props.handleNext} prevStep={props.handleBack} listingData={props.listingData}/>}
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
  }
}

export default connect(mapStateToProps)(ProductListingHeader);